module.exports = __webpack_public_path__ + "assets/img/customerService-153b8cdf.png";